export const FETCH_WEBENQUIRY = "app/WebEnquiries/FETCH_WEBENQUIRY";
export const FETCH_WEBENQUIRY_SUCCESS =
  "app/WebEnquiries/FETCH_WEBENQUIRY_SUCCESS";
export const FETCH_WEBENQUIRY_FAILURE =
  "app/WebEnquiries/FETCH_WEBENQUIRY_FAILURE";

// ADD
export const ADD_WEBENQUIRY = "app/WebEnquiries/ADD_WEBENQUIRY";
export const ADD_WEBENQUIRY_SUCCESS = "app/WebEnquiries/ADD_WEBENQUIRY_SUCCESS";
export const ADD_WEBENQUIRY_FAILURE = "app/WebEnquiries/ADD_WEBENQUIRY_FAILURE";

// EDIT
export const EDIT_WEBENQUIRY = "app/WebEnquiries/EDIT_WEBENQUIRY";
export const EDIT_WEBENQUIRY_SUCCESS =
  "app/WebEnquiries/EDIT_WEBENQUIRY_SUCCESS";
export const EDIT_WEBENQUIRY_FAILURE =
  "app/WebEnquiries/EDIT_WEBENQUIRY_FAILURE";

// DELETE
export const DELETE_WEBENQUIRY = "app/WebEnquiries/DELETE_WEBENQUIRY";
export const DELETE_WEBENQUIRY_SUCCESS =
  "app/WebEnquiries/DELETE_WEBENQUIRY_SUCCESS";
export const DELETE_WEBENQUIRY_FAILURE =
  "app/WebEnquiries/DELETE_WEBENQUIRY_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/WebEnquiries/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/WebEnquiries/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/WebEnquiries/GET_VIEW_DATA_FAILURE";

// DELETE
export const DELETE_WEBENQ = "app/WebEnquiries/DELETE_WEBENQ";
export const DELETE_WEBENQ_SUCCESS = "app/WebEnquiries/DELETE_WEBENQ_SUCCESS";
export const DELETE_WEBENQ_FAILURE = "app/WebEnquiries/DELETE_WEBENQ_FAILURE";

// DELETE
export const CONVERT_LEAD = "app/WebEnquiries/CONVERT_LEAD";
export const CONVERT_LEAD_SUCCESS = "app/WebEnquiries/CONVERT_LEAD_SUCCESS";
export const CONVERT_LEAD_FAILURE = "app/WebEnquiries/CONVERT_LEAD_FAILURE";

export const TOGGLE_CONVERT = "app/WebEnquiries/TOGGLE_CONVERT";

export const GET_REPORT = "app/WebEnquiries/GET_REPORT";
export const GET_REPORT_SUCCESS = "app/WebEnquiries/GET_REPORT_SUCCESS";
export const GET_REPORT_FAILURE = "app/WebEnquiries/GET_REPORT_FAILURE";

export const GET_TYPE_REPORT = "app/WebEnquiries/GET_TYPE_REPORT";
export const GET_TYPE_REPORT_SUCCESS =
  "app/WebEnquiries/GET_TYPE_REPORT_SUCCESS";
export const GET_TYPE_REPORT_FAILURE =
  "app/WebEnquiries/GET_TYPE_REPORT_FAILURE";

export const GET_REF_REPORT = "app/WebEnquiries/GET_REF_REPORT";
export const GET_REF_REPORT_SUCCESS = "app/WebEnquiries/GET_REF_REPORT_SUCCESS";
export const GET_REF_REPORT_FAILURE = "app/WebEnquiries/GET_REF_REPORT_FAILURE";

export const SET_REPORT = "app/WebEnquiries/SET_REPORT";

export const SET_DIGITAL_DATA = "app/WebEnquiries/SET_DIGITAL_DATA";
export const SET_RECOMM_DATA = "app/WebEnquiries/SET_RECOMM_DATA";
export const SET_LOCAL_DATA = "app/WebEnquiries/SET_LOCAL_DATA";
export const SET_ADVERT_DATA = "app/WebEnquiries/SET_ADVERT_DATA";
